import bridge from "@vkontakte/vk-bridge";

import { updateUserStateParams } from '../../app/store/userReducer';
import { setRouteName } from '../../app/store/routerReducer';
import { ROUTE_DATE_PICKER } from '../../app/router';

export const resetThunk = () => {

    return (dispatch, getState) => {

        let state = getState();
        
        dispatch(updateUserStateParams({
            birthDayInput: '',
            birthMonthInput: '',
            birthYearInput: '',
        }));

        dispatch(setRouteName(ROUTE_DATE_PICKER));

        if (state.app.searchParams && state.app.searchParams.vk_platform && state.app.searchParams.vk_platform === "desktop_web") {
            bridge.send("VKWebAppResizeWindow", {
                "width": 700,
                "height": 700,
            }).then((data) => {
                // Обработка события в случае успеха
                //console.log('VKWebAppResizeWindow res', data);
            })
            .catch((error) => {
                // Обработка события в случае ошибки
                console.log('VKWebAppResizeWindow error', error);
            });

            bridge.send("VKWebAppScroll", {"top": 0, "speed": 500});
        }
    }
}
